import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useFetch from "../../../../hooks/use-fetch";
import HtmlInput from "../../../UI/HtmlInput";
import LanguageDropdown from "../../../UI/LanguageDropdown";
import Fragment from "./Fragment";

const LearntFragments = ({setActiveSection}) => {
    const {t: translate } = useTranslation();
    const {apiUrl} = window['appConfig']
    const {data:fragmentsData, error: fragmentErrors, initFunc: fetchFragmentData} = useFetch();
    const [userFragments, setUserFragments] = useState({})
    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [errors, setErrors] = useState(null);
    const [filteredLang, setFilteredLang] = useState('')
    const [fragmentSearch, setFragmentSearch] = useState('')
    const fetchOptions = {
        method: 'GET',
    };
    const userProfileArchives = localStorage.getItem('glup') ? JSON.parse(localStorage.getItem('glup')) : {};
    
    useEffect(() => {
        if( userProfileArchives && Object.prototype.hasOwnProperty.call(userProfileArchives, 'fragments') ) {
            setData(userProfileArchives.fragments);
            setUserFragments(userProfileArchives.fragments);
            setIsLoading(false);
        } else {
            setIsLoading(true);
            fetchFragmentData({url:`${apiUrl}/progress/fragments?format=mp3`, options: fetchOptions})
        }
    }, [])

    useEffect(() => {
        if( fragmentsData ) {
            setData(fragmentsData)
            setUserFragments(fragmentsData)
            setIsLoading(false);
            userProfileArchives.fragments = fragmentsData;
            localStorage.setItem('glup', JSON.stringify(userProfileArchives));
        }
    }, [fragmentsData])

    useEffect(() => {
        if(fragmentErrors) {
            setErrors(fragmentErrors)
        }
    }, [fragmentErrors])

    useEffect(() => {
        if( fragmentSearch !== '' || filteredLang !== '') {
            setUserFragments(
                data.filter((fragment) => {
                    if(filteredLang === '') {
                        if((fragment.learningLang).toLowerCase().includes(fragmentSearch.toLowerCase())) {
                            return fragment;
                        }
                        
                        if((fragment.nativeLang).toLowerCase().includes(fragmentSearch.toLowerCase())) {
                            return fragment;
                        }
                    } else if( (fragment.language).toLowerCase() === filteredLang ) {
                        if((fragment.learningLang).toLowerCase().includes(fragmentSearch.toLowerCase())) {
                            return fragment;
                        }
                        
                        if((fragment.nativeLang).toLowerCase().includes(fragmentSearch.toLowerCase())) {
                            return fragment;
                        }
                    }
                })
            )
        }
        //  else {
        //     setUserFragments(data)
        // }
    },[fragmentSearch, filteredLang])

    if( isLoading ) {
        return <div className={`user-dashboard user-dashboard__inner`}>
            <div className="user-dashboard__header">
                <button className="user-dashboard__back" onClick={() => {setActiveSection('')}}><FontAwesomeIcon icon={faChevronLeft} size="1x" /> {translate('back')}</button>
                <h4 className="user-dashboard__title">{translate('learnt-fragments')}</h4>
            </div>
            <p className="user-dashboard__loading"></p>
        </div>
    }

    if( errors ) {
        return (
            <div className={`user-dashboard user-dashboard__inner`}>
                <div className="user-dashboard__header">
                    <button className="user-dashboard__back" onClick={() => {setActiveSection('')}}><FontAwesomeIcon icon={faChevronLeft} size="1x" /> {translate('back')}</button>
                    <h4 className="user-dashboard__title">{translate('learnt-fragments')}</h4>
                    <div className="dashboard-section">
                        <h4 className="dashboard-section__title">{translate('error-has-occured')}</h4>
                        <div className="error-container">
                            <details  className="error-report" style={{ whiteSpace: 'pre-wrap' }}>{errors}</details>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    // eslint-disable-next-line no-use-before-define
    const handleDropdownChange = (name, value) => {
        if( value === translate('all-languages') ) {
            value = '';
        } 
        setFilteredLang(value);
    };

    return (
        <div className={`user-dashboard user-dashboard__inner`}>
            <div className="user-dashboard__header">
                <button className="user-dashboard__back" onClick={() => {setActiveSection('')}}><FontAwesomeIcon icon={faChevronLeft} size="1x" /> {translate('back')}</button>
                <h4 className="user-dashboard__title">{translate('learnt-fragments')}</h4>
            </div>
            <div className="fragment-filters">
                <HtmlInput 
                    id="fragment_search"
                    name="fragment_search"
                    legend={translate('find-fragment')}
                    value={fragmentSearch}
                    changeCallback={e => setFragmentSearch(e.target.value)}
                    hasErrors={false}
                />
                <LanguageDropdown 
                    onClickHandler={handleDropdownChange}
                    name={'fragment-lang'}
                    position={'bottom'}
                    allowGa={false}
                    allowClear={true}
                    placeholderText={translate('all-languages')}
                />
            </div>
            <div className="learnt-fragments">
                {userFragments && <div className="learnt-fragments__container">
                    {userFragments.map((fragment, index) => {
                        return (
                            <Fragment fragment={fragment} index={index} key={index}/>
                            )
                    })}
                </div>}
                {userFragments.length === 0 && <div className="learnt-fragments__container">
                    <p className="no-fragments">{translate('no-fragments-found')}</p>
                </div>}
            </div>
        </div>
    )
}

export default LearntFragments